/**
 * Terms of Service Page
 */

import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export function TermsOfServicePage() {
  return (
    <div className="container py-8 max-w-4xl">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={18} />
        홈으로 이동
      </Link>

      <div className="bg-white rounded-xl border p-8">
        <div className="flex items-center gap-3 mb-6">
          <FileText className="text-orange-500" size={28} />
          <h1 className="text-2xl font-bold text-gray-900">이용약관</h1>
        </div>

        <p className="text-sm text-gray-500 mb-8">
          최종 수정일: 2026년 2월 22일
        </p>

        <div className="prose prose-gray max-w-none">
          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">1. 서비스 안내</h2>
            <p className="text-gray-600">
              moapc.com은 컴퓨터 부품 및 전자제품 정보를 제공하는 플랫폼입니다.
              본 사이트는 제품 정보를 제공하며, 실제 구매는 AliExpress, Coupang 등
              제휴사 사이트에서 이루어집니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">2. 제휴 링크</h2>
            <p className="text-gray-600">
              본 사이트의 제품 링크는 제휴 마케팅 링크일 수 있습니다.
              링크를 통해 구매 시 본 사이트에 수수료가 지급될 수 있으며,
              이는 구매 가격에 영향을 주지 않습니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">3. 정보의 정확성</h2>
            <p className="text-gray-600">
              본 사이트는 최신 정보를 제공하기 위해 노력하지만,
              제품 가격, 재고 상태 등은 실시간으로 변경될 수 있습니다.
              정확한 정보는 판매처 사이트에서 확인하시기 바랍니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">4. 책임의 한계</h2>
            <p className="text-gray-600">
              본 사이트는 제휴사 사이트에서의 거래에 대해 책임을 지지 않습니다.
              제품 품질, 배송, 환불 등은 해당 판매처의 정책을 따릅니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">5. 지적재산권</h2>
            <p className="text-gray-600">
              본 사이트의 콘텐츠는 저작권의 보호를 받습니다.
              상업적 목적 없이 개인적으로 사용할 수 있습니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">6. 약관 변경</h2>
            <p className="text-gray-600">
              본 사이트는 필요시 이용약관을 변경할 수 있습니다.
              변경된 약관은 본 페이지에 게시됩니다.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
